import React, { LinkHTMLAttributes } from 'react';
import Head from 'next/head';
import { useTenantConfig } from '../contexts';

export interface HeadSectionProps {
  title?: string;
  metaTitle?: string;
  description?: string | false;
  keywords?: string;
  image?: string;
  canonical?: string;
  prevHref?: string;
  nextHref?: string;
  noindex?: boolean;
  links?: LinkHTMLAttributes<HTMLLinkElement>[];
}

export const HeadSection: React.FC<HeadSectionProps> = ({
  title,
  metaTitle,
  description,
  keywords,
  image,
  canonical,
  prevHref,
  nextHref,
  noindex = false,
  links,
}: HeadSectionProps) => {
  const { meta } = useTenantConfig();
  return (
    <Head>
      <title>{title || meta.title}</title>
      <meta name="title" content={metaTitle || title || meta.title} />
      <meta property="og:title" content={metaTitle || title || meta.title} />
      {description !== false && (
        <meta name="description" content={description || meta.description} />
      )}
      {keywords && <meta name="keywords" content={keywords} />}
      {description !== false && (
        <meta
          property="og:description"
          content={description || meta.description}
        />
      )}
      <meta name="image" content={image || meta.image} />
      <meta property="og:image" content={image || meta.image} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      {canonical && <link rel="canonical" href={canonical} />}
      {prevHref && <link rel="prev" href={prevHref} />}
      {nextHref && <link rel="next" href={nextHref} />}
      {links?.map((attrs) => Object.keys(attrs).length && <link {...attrs} />)}
      {meta.dcmaVerificationContent && (
        <meta
          name="dmca-site-verification"
          content={meta.dcmaVerificationContent}
        />
      )}
    </Head>
  );
};
